import { commonV2URL } from 'src/constantsMessage';
import axios from 'src/utils/axiosHelper';
import { SET_ALERT } from 'src/actions/alertAction';
import helperAxios from 'src/utils/helperAxios';
import { logout } from './accountActions';

export const GET_ROLE = '@common/get-role';
export const GET_ROLE_ERROR = '@common/get-role-error';
export const GET_BANK = '@common/get-bank';
export const GET_BANK_ERROR = '@common/get-bank-error';
export const GET_BANK_EMPTY = '@common/get-bank-empty';
export const GET_PAGE_WIDTH = '@common/get-page-width';

export function getAllRole() {
  const url = `${commonV2URL}/role/all`;
  const request = helperAxios(url, 'get');

  return dispatch => {
    request
      .then(response =>
        dispatch({
          type: GET_ROLE,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_ROLE_ERROR,
          payload: error.response.data
        });
      });
  };
}

export function getAllBank(name) {
  const url = `${commonV2URL}/bank?search=${name || ''}`;
  const request = helperAxios(url, 'get');

  return dispatch => {
    request
      .then(response =>
        dispatch({
          type: GET_BANK,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_BANK_ERROR,
          payload: error.response && error.response.data
        });
      });
  };
}

export const getAllBankError = error => {
  if (error && error.error.includes('Invalid or Expired token')) logout();
  else
    return dispatch => {
      dispatch({ type: GET_BANK_ERROR, payload: error });
    };
};

export const getAllBankEmpty = () => {
  return dispatch => {
    dispatch({ type: GET_BANK_EMPTY });
  };
};

export const getPageWidth = width => {
  return dispatch => {
    dispatch({ type: GET_PAGE_WIDTH, payload: width });
  };
};
